import { render, staticRenderFns } from "./employee-notifications.vue?vue&type=template&id=74fb5662&scoped=true"
import script from "./employee-notifications.vue?vue&type=script&lang=js"
export * from "./employee-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fb5662",
  null
  
)

export default component.exports